import { API } from '../../utils';
import { IParams } from '../types';
import { GW_SERVICES_PREFIXES } from 'constants/gateway';

const { C300, REQUEST } = GW_SERVICES_PREFIXES;

/* Отчёт "Просроченные счётчики" как в старой системе (нужно для выгрузки в Excel старого формата).
GET нет, так как делается window.open для Excel сразу */
export const CreateOldOverdueMetersReport = (params: IParams) =>
  API.gatewayPost(`/${C300}/report/meters_overdue/`, params);

/* Новый отчёт "Просроченные счётчики" */
export const CreateNewOverdueMetersReport = (params: IParams) =>
  API.gatewayPost(`/${C300}/report/overdue_meters/xlsx/`, params);

export const CreateOverdueMetersReportPoint = (params: IParams) =>
  API.gatewayPost(`/${C300}/report/overdue_meters/points/`, params); // Запрос координат домов

/* Отчёт "Просроченные счётчики" по домам (не как в старой системе) */
export const CreateOverdueMetersReportGroup = (params: IParams) =>
  API.gatewayPost(`/${C300}/overdue_meters/groups/`, params); // Запрос создания групп на карте

export const CreateOverdueMetersReport = (params: IParams) =>
  API.gatewayPost(`/${C300}/report/overdue_meters/houses/`, params); // Запрос домов по параметрам

export const CreateOverdueMetersReportByPhone = (params: IParams) =>
  API.gatewayPost(`/${C300}/report/meters_overdue_houses_by_phone/`, params); // Запрос домов по номеру телефона

export const GetOverdueMetersReportGroup = () =>
  API.get(`/${C300}/overdue_meters/groups/`); // Запрос групп на карте

export const GetOverdueMetersReportData = (params: IParams) =>
  API.get(`/${C300}/report/meters_overdue_houses/`, undefined, params);

export const GetOverdueMetersReportDataByPhone = (params: IParams) =>
  API.get(`/${C300}/report/meters_overdue_houses_by_phone/`, undefined, params);

/* Отчёт "Просроченные счётчики" по дому (не как в старой системе) */
export const CreateOverdueMetersReportByHouse = (params: IParams) =>
  API.gatewayPost(`/${C300}/report/overdue_meters/house/`, params); // Запрос получения информации о доме

export const CreateOverdueMetersReportByHouseAndPhone = (params: IParams) =>
  API.gatewayPost(`/${C300}/report/meters_overdue_house_by_phone/`, params);

export const GetOverdueMetersReportByHouseData = (params: IParams) =>
  API.get(`/${C300}/report/meters_overdue_house/`, undefined, params);

export const GetOverdueMetersReportByHouseAndPhoneData = (params: IParams) =>
  API.get(`/${C300}/report/meters_overdue_house_by_phone/`, undefined, params);

/* Добавление нового статуса в отчёте по просроченным счётчикам */
export const UpdateHistoryMetersStatus = (params: IParams) =>
  API.gatewayPatch(`/${C300}/history-meters/update-status/`, undefined, params);

/* Добавление и изменение комментария в отчёте по просроченным счётчикам */
export const UpdateHistoryMetersComment = (params: IParams) =>
  API.gatewayPatch(
    `/${C300}/history-meters/update-comment/`,
    undefined,
    params
  );

/* Добавление и изменение списка счётчиков в отчёте по просроченным счётчикам */
export const UpdateHistoryMetersList = (params: IParams) =>
  API.gatewayPatch(`/${C300}/history-meters/update-meters/`, undefined, params);

/* Получение актуального статуса заявки в отчёте по просроченным счётчикам */
export const UpdateHistoryMetersRequest = (params: IParams) =>
  API.gatewayPatch(
    `/${C300}/history-meters/update-request/`,
    undefined,
    params
  );

/* Изменение параметров группы */
export const UpdateOverdueMetersReportGroup = (id: string, params: IParams) =>
  API.gatewayPatch(`/${C300}/overdue_meters/groups/`, id, params);

/* Удаление объекта истории history_meters */
export const DeleteHistoryMeters = (history_id: string) =>
  API.delete('/history-meters/delete/', history_id);

/* Удаление группы на карте */
export const DeleteOverdueMetersReportGroup = (id: string) =>
  API.delete(`/${C300}/overdue_meters/groups/${id}/`);

export const GetRequestsReportDeptData = (params: IParams) =>
  API.get(`/${REQUEST}/stat/request_by_department/`, undefined, params);

export const GetRequestsReportProviderData = (params: IParams) =>
  API.get(`/${REQUEST}/stat/request_by_provider/`, undefined, params);

export const GetRequestsReportCategoriesData = (params: IParams) =>
  API.get(`/${REQUEST}/stat/request_category/`, undefined, params);

export const GetRequestsReportHistory = () =>
  API.get(`/${REQUEST}/request/log_history/`);

export const GetRequestsReportHistoryById = (params: IParams) =>
  API.get(`/${REQUEST}/request/log_history/`, params.id as string);

export const CreateReportLink = (params: IParams) =>
  API.gatewayPatch(
    `/${REQUEST}/request/log_history/linked/`,
    params.id as string
  );

export const PatchSavedField = (params: IParams) =>
  API.gatewayPatch(
    `/${REQUEST}/request/log_history/saved/`,
    params.id as string
  );

export const GetRequestsReportDayInfo = (params: IParams) =>
  API.get(`/${REQUEST}/stat/request_by_day_category/`, undefined, params);

export const CreateExcelRequestsReport = (params: IParams) =>
  API.gatewayPost(`/${REQUEST}/stat/request_by_department/xlsx/`, params);
